
define('sites/socialpsychology.org/routes',[],function() {

	// We only look for *spats and :params
	// Lets write a script that will automatically find the correct files by traversing filesystem.
	// instead of traversing page directory we should traverse this app list.

	// think about autogenerated tokens and caching of js files.

	return {
		www: {
			"": {
				app: "index"
			},
			"login": {
				app: "login",
				title: "SPN Account Sign In",
				browser: ["msie 10", "safari 6", "firefox 21"]
			},
			"search": {
				app: "search",
				title: "SPN Search"
			},
			"search/:type": {
				extend: ["www", "search"],
			},
			"maps/experts": { //"search/:type/:subparam": {
				extend: ["www", "search"],
				title: 'SPN Expert GeoSearch'
			},
			"maps/researchgroups": { //"search/:type/:subparam": {
				extend: ["www", "search"],
				title: 'SPN Research Group GeoSearch'
			},
			"maps/gradprograms": { //"search/:type/:subparam": {
				extend: ["www", "search"],
				title: 'SPN Graduate Programs GeoSearch'
			},
			"maps/gradprograms-test": {
				app: "search-test",
				title: "SPN Graduate Programs GeoSearch TEST"
			},
			"maps/experts-test": {
				app: "search-test",
				title: "SPN Expert GeoSearch TEST"
			},
			"maps/researchgroups-test": {
				app: "search-test",
				title: "SPN Research Group GeoSearch TEST"
			},
			"already-activated": {
				app: "temp-member-link"
			},
			"already-activated/:username": {
				extend: ["www", "already-activated"]
			},
			"account": {
				app: "account",
				title: "My Account",
				browser: ["msie 10", "safari 6", "firefox 21"]
			},
			"account/:tab": {
				extend: ["www", "account"]
			},
			"admin/account/edit/:id": {
				extend: ["www", "account"],
				title: 	"Account for [NAME]"
			},
			"admin/account/edit/:id/:tab": {
				extend: ["www", "account"],
				title: 	"Account for [NAME]"
			},
			"application":{
				app: "application",
				title: "Profile Application"
			},
			"error/404": {
				app: "error/404"
			},
			"error/500": {
				app: "error/500"
			},
			"error/maintenance": {
				app: "error/maintenance"
			},
			"member/:username": {
				app: "profile"
			},
			"member/:username/:page": {
				extend: ["www", "member/:username"]
			},
			"thank-you": {
				app: "temporary-thankyou"
			},
			"thank-you/profile": {
				app: "temporary-thankyou"
			},
			"thank-you/member": {
				app: "temporary-thankyou"
			},
			"thank-you/coursera":{
				app:"temporary-thankyou"
			},
			"thank-you/member/new": {
				app: "temporary-thankyou"
			},
			"thank-you/donation": {
				app: "temporary-thankyou"
			},
			"thank-you/donation/monthly": {
				app: "temporary-thankyou"
			},
			"reset/:key": {
				title: "Reset Password",
				app: "resetPassword"
			},
			"draw": {
				app: "draw"
			},
			"membership-directory": {
				app: "membership-directory",
				title: "Social Psychology Network Membership Directory"
			},
			"teaching": {
				app: "static"
			},
			/*
			"testpage": {
				app: "testpage"
			},
			*/
			"unsubscribe":{
				app:"static"
			},
			"videos/files-tour":{
				app:"static"
			}
			// "heartbleed": {
			// 	app: "static"
			// },

		//	"admin/day-logger": {
		//		app: "dayLogger"
		//	}
		},
		profile: {
			"": {
				app: "profile"
			},
			":page": {
				extend: ["profile", ""]
			}
		}
	};

});
